@if (iconName()) {
  <span class="lib-svg-icon" [innerHTML]="icon()">
</span>
}
